import { render, staticRenderFns } from "./ICPNudgeModal.vue?vue&type=template&id=4a68f7e6&"
import script from "./ICPNudgeModal.vue?vue&type=script&lang=ts&"
export * from "./ICPNudgeModal.vue?vue&type=script&lang=ts&"
import style0 from "./ICPNudgeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4a68f7e6', component.options)
    } else {
      api.reload('4a68f7e6', component.options)
    }
    module.hot.accept("./ICPNudgeModal.vue?vue&type=template&id=4a68f7e6&", function () {
      api.rerender('4a68f7e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/courses/CoursePage/components/ICPNudgeModal.vue"
export default component.exports